(function () {
  document.querySelectorAll('[data-premium-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('.gallery__main-img');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.thumb'));
    var arrows = gallery.querySelectorAll('.arrow');
    if (!mainImg || !thumbs.length) return;

    var current = thumbs.findIndex(function (t) {
      return t.classList.contains('is-active');
    });
    if (current < 0) current = 0;

    function show(index) {
      current = (index + thumbs.length) % thumbs.length;
      var thumb = thumbs[current];
      var src = thumb.getAttribute('data-media-src');
      if (src) mainImg.setAttribute('src', src);
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === current);
      });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        show(i);
      });
    });

    arrows.forEach(function (a) {
      a.addEventListener('click', function () {
        var dir = parseInt(a.getAttribute('data-dir'), 10) || 1;
        show(current + dir);
      });
    });
  });

  document.querySelectorAll('[data-cts-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-cts-track]');
    var prev = carousel.querySelector('[data-cts-prev]');
    var next = carousel.querySelector('[data-cts-next]');
    if (!track) return;

    function scrollAmount() {
      var card = track.querySelector('.card');
      if (!card) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
      return card.offsetWidth + gap;
    }

    function updateNav() {
      var overflow = track.scrollWidth > track.clientWidth + 2;
      carousel.classList.toggle('has-overflow', overflow);
      if (prev) prev.hidden = !overflow;
      if (next) next.hidden = !overflow;
      if (!overflow) return;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  });

  document.querySelectorAll('.premium-pdp').forEach(function (root) {
    root.querySelectorAll('[data-cts-checkbox]').forEach(function (input) {
      input.addEventListener('change', function () {
        var card = input.closest('[data-cts-card]');
        if (!card) return;
        card.style.borderColor = input.checked ? 'var(--premium-gold)' : 'var(--premium-border-gray)';
      });
    });

    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      var extras = Array.prototype.slice
        .call(root.querySelectorAll('[data-cts-checkbox]:checked'))
        .map(function (input) {
          return { id: input.value, quantity: 1 };
        })
        .filter(function (item) {
          return item.id;
        });

      if (!extras.length) return;

      event.preventDefault();

      var mainId = form.querySelector('[name="id"]').value;
      var items = [{ id: mainId, quantity: 1 }].concat(extras);

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart add failed');
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        })
        .catch(function () {
          form.submit();
        });
    });
  });
})();
